export const theme = {
  "zIndex": {
    "hide": -1,
    "auto": "auto",
    "dropdown": 1000,
    "tooltip": 1100,
    "loadingOverlay": 1200,
    "dropdownInPortal": 1300,
    "modal": 1300,
    "popover": 1300,
    "toast": 1400
  },
  "font": {
    "family": {
      "default": "Graphik, Arial, Helvetica, sans-serif",
      "graphik": "Graphik, Arial, Helvetica, sans-serif",
      "inter": "Inter, system-ui, sans-serif",
      "heading": "'Factor A', system-ui, sans-serif",
      "mono": "ui-monospace, 'Cascadia Code', 'Source Code Pro', Menlo, Consolas, 'DejaVu Sans Mono', monospace"
    },
    "weight": {
      "regular": "400",
      "strong": "500"
    },
    "size": {
      "heading1": "32px",
      "heading2": "30px",
      "heading3": "24px",
      "heading4": "21px",
      "default": "15px",
      "small": "14px",
      "caption": "13px",
      "tiny": "11px"
    },
    "line-height": {
      "heading1": "44.8px",
      "heading2": "42px",
      "heading3": "34px",
      "heading4": "29px",
      "default": "21px",
      "small": "20px",
      "caption": "18px"
    },
    "decoration": {
      "underline": "underline"
    }
  },
  "motion": {
    "standard": "cubic-bezier(0.5, 0, 0.1, 1)",
    "in": "cubic-bezier(0.25, 0, 1, 1)",
    "out": "cubic-bezier(0, 0, 0.25, 1)",
    "bounce": "cubic-bezier(0.47, 1.64, 0.41, 0.8)",
    "speed": {
      "1": "180ms",
      "2": "260ms",
      "3": "340ms",
      "4": "680ms",
      "5": "860ms"
    }
  },
  "radius": {
    "s": "2px",
    "m": "4px",
    "l": "8px",
    "xl": "12px",
    "rounded": "9999px",
    "input": "4px",
    "notification": "4px",
    "button": {
      "default": "4px",
      "small": "4px"
    },
    "iconbutton": "4px",
    "card": "4px",
    "tooltip": "4px",
    "tag": "9999px",
    "status": "9999px",
    "modal": "4px",
    "dropdown": "4px"
  },
  "size": {
    "height": {
      "input": {
        "default": "35px",
        "small": "30px"
      },
      "button": {
        "large": "45px",
        "default": "35px",
        "small": "30px",
        "extra-small": "20px"
      },
      "iconbutton": {
        "large": "45px",
        "default": "32px",
        "small": "24px",
        "extra-small": "20px"
      }
    },
    "border": {
      "button": {
        "default": "1px"
      }
    }
  },
  "spacing": [
    "0",
    "4px",
    "8px",
    "12px",
    "16px",
    "20px",
    "24px",
    "32px",
    "40px",
    "48px",
    "56px",
    "64px",
    "72px",
    "80px",
    "96px"
  ],
  "transition": {
    "default": "0.2s"
  },
  "typography": {
    "heading": {
      "1": {
        "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
        "fontWeight": "500",
        "fontSize": "32px",
        "lineHeight": "44.8px"
      },
      "2": {
        "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
        "fontWeight": "400",
        "fontSize": "30px",
        "lineHeight": "42px"
      },
      "3": {
        "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
        "fontWeight": "500",
        "fontSize": "24px",
        "lineHeight": "34px"
      },
      "4": {
        "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
        "fontWeight": "500",
        "fontSize": "21px",
        "lineHeight": "29px"
      }
    },
    "body": {
      "base": {
        "default": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "15px",
          "lineHeight": "21px"
        },
        "strong": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "500",
          "fontSize": "15px",
          "lineHeight": "21px"
        }
      },
      "small": {
        "default": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "14px",
          "lineHeight": "20px"
        },
        "strong": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "500",
          "fontSize": "14px",
          "lineHeight": "20px"
        }
      },
      "caption": {
        "default": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "13px",
          "lineHeight": "18px"
        },
        "strong": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "500",
          "fontSize": "13px",
          "lineHeight": "18px"
        }
      },
      "tiny": {
        "default": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "11px",
          "lineHeight": "15px"
        },
        "strong": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "500",
          "fontSize": "11px",
          "lineHeight": "15px"
        }
      },
      "link": {
        "default": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "15px",
          "lineHeight": "21px",
          "textDecoration": "underline"
        },
        "small": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "14px",
          "lineHeight": "20px",
          "textDecoration": "underline"
        },
        "caption": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "13px",
          "lineHeight": "18px",
          "textDecoration": "underline"
        }
      },
      "action": {
        "base": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "14px",
          "lineHeight": "16px"
        },
        "small": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "12px",
          "lineHeight": "14px"
        }
      }
    }
  },
  "color": {
    "text": {
      "brand": {
        "primary": "#FFECD3"
      },
      "default": "hsl(204 45% 98% / 0.72)",
      "inverse": "hsl(210 11% 7% / 0.72)",
      "light": {
        "default": "hsl(204 45% 98% / 0.72)",
        "inverse": "hsl(210 11% 7% / 0.72)"
      },
      "disabled": "hsl(204 45% 98% / 0.40)",
      "link": {
        "default": "#BFDBFE",
        "hover": "#DBEAFE"
      },
      "active": "#BFDBFE",
      "danger": "#FEE9E6",
      "success": "#DCFAE1",
      "info": "#CFFAFE",
      "warning": "#FEF9C3",
      "ai": "#EDE9FE",
      "input": {
        "placeholder": "hsl(204 45% 98% / 0.40)"
      },
      "action": {
        "primary": "#172D6E",
        "danger": "#8A1505",
        "alt": {
          "primary": "#EFF6FF",
          "danger": "#FEF2F0"
        }
      },
      "button": {
        "accent": {
          "primary": {
            "default": "#172D6E",
            "hover": "#172D6E",
            "pressed": "#172D6E",
            "disabled": "hsl(204 45% 98% / 0.40)"
          },
          "secondary": {
            "default": "#EFF6FF",
            "hover": "#EFF6FF",
            "pressed": "#EFF6FF",
            "disabled": "hsl(204 45% 98% / 0.40)"
          },
          "tertiary": {
            "default": "hsl(204 45% 98% / 0.72)",
            "hover": "hsl(204 45% 98% / 0.72)",
            "pressed": "hsl(204 45% 98% / 0.72)",
            "disabled": "hsl(204 45% 98% / 0.40)"
          }
        },
        "danger": {
          "primary": {
            "default": "#8A1505",
            "hover": "#8A1505",
            "pressed": "#8A1505",
            "disabled": "hsl(204 45% 98% / 0.40)"
          },
          "secondary": {
            "default": "#FEF2F0",
            "hover": "#FEF2F0",
            "pressed": "#FEF2F0",
            "disabled": "hsl(204 45% 98% / 0.40)"
          },
          "tertiary": {
            "default": "#FEF2F0",
            "hover": "#FEF2F0",
            "pressed": "#FEF2F0",
            "disabled": "hsl(204 45% 98% / 0.40)"
          }
        }
      }
    },
    "border": {
      "default": "#454F59",
      "light": "#282E33",
      "disabled": "#38414A",
      "active": "#93C5FD",
      "danger": "#B11B07",
      "success": "#0F611E",
      "info": "#155E75",
      "warning": "#854D0E",
      "ai": "#5B21B6",
      "input": {
        "default": "#454F59",
        "hover": "#596773",
        "readonly": "#1D2125"
      },
      "button": {
        "accent": {
          "primary": {
            "default": "hsl(210 11% 7% / 0.01)",
            "hover": "hsl(210 11% 7% / 0.01)",
            "pressed": "hsl(210 11% 7% / 0.01)",
            "disabled": "hsl(210 11% 7% / 0.01)"
          },
          "secondary": {
            "default": "#454F59",
            "hover": "#596773",
            "pressed": "#596773",
            "disabled": "hsl(210 11% 7% / 0.01)"
          },
          "tertiary": {
            "default": "hsl(210 11% 7% / 0.01)",
            "hover": "hsl(210 11% 7% / 0.01)",
            "pressed": "hsl(210 11% 7% / 0.01)",
            "disabled": "hsl(210 11% 7% / 0.01)"
          }
        },
        "danger": {
          "primary": {
            "default": "hsl(210 11% 7% / 0.01)",
            "hover": "hsl(210 11% 7% / 0.01)",
            "pressed": "hsl(210 11% 7% / 0.01)",
            "disabled": "hsl(210 11% 7% / 0.01)"
          },
          "secondary": {
            "default": "#B11B07",
            "hover": "#B11B07",
            "pressed": "#B11B07",
            "disabled": "hsl(210 11% 7% / 0.01)"
          },
          "tertiary": {
            "default": "hsl(210 11% 7% / 0.01)",
            "hover": "hsl(210 11% 7% / 0.01)",
            "pressed": "hsl(210 11% 7% / 0.01)",
            "disabled": "hsl(210 11% 7% / 0.01)"
          }
        }
      }
    },
    "background": {
      "transparent": "hsl(210 11% 7% / 0.01)",
      "surface": {
        "default": "#101214",
        "inverse": "#FFFFFF",
        "middle": "#1D2125",
        "fore": "#282E33"
      },
      "default": "#38414A",
      "disabled": "#38414A",
      "active": "#172D6E",
      "danger": "#8A1505",
      "success": "#083510",
      "info": "#164E63",
      "warning": "#713F12",
      "ai": "#4C1D95",
      "mask": "#A6C5E229",
      "input": {
        "default": "#101214",
        "readonly": "#1D2125"
      },
      "toggle": {
        "default": "#38414A",
        "active": "#BDF5C7"
      },
      "switch": {
        "default": "#38414A",
        "active": "#1DBE3A",
        "disabled": "#38414A",
        "error": "#8A1505",
        "marker": {
          "default": "#454F59",
          "active": "#16922D",
          "error": "#B11B07"
        },
        "control": {
          "default": "#FFFFFF",
          "disabled": "#282E33"
        }
      },
      "progress": {
        "default": "#282E33",
        "active": {
          "default": "#BFDBFE",
          "light": "#2563EB"
        }
      },
      "action": {
        "primary": {
          "default": "#BFDBFE",
          "hover": "#DBEAFE",
          "pressed": "#DBEAFE"
        },
        "secondary": {
          "default": "hsl(210 11% 7% / 0.01)",
          "hover": "#BCD6F00A",
          "pressed": "#A1BDD914"
        },
        "tertiary": {
          "default": "hsl(210 11% 7% / 0.01)",
          "hover": "#BCD6F00A",
          "pressed": "#A1BDD914"
        },
        "danger": {
          "default": "#FDD3CE",
          "hover": "#FEE9E6",
          "pressed": "#FEE9E6",
          "light": {
            "default": "hsl(210 11% 7% / 0.01)",
            "hover": "#8A1505",
            "pressed": "#B11B07"
          }
        }
      },
      "button": {
        "accent": {
          "primary": {
            "default": "#BFDBFE",
            "hover": "#DBEAFE",
            "pressed": "#DBEAFE",
            "disabled": "#38414A"
          },
          "secondary": {
            "default": "hsl(210 11% 7% / 0.01)",
            "hover": "#BCD6F00A",
            "pressed": "#A1BDD914",
            "disabled": "#38414A"
          },
          "tertiary": {
            "default": "hsl(210 11% 7% / 0.01)",
            "hover": "#BCD6F00A",
            "pressed": "#A1BDD914",
            "disabled": "#38414A"
          }
        },
        "danger": {
          "primary": {
            "default": "#FDD3CE",
            "hover": "#FEE9E6",
            "pressed": "#FEE9E6",
            "disabled": "#38414A"
          },
          "secondary": {
            "default": "hsl(210 11% 7% / 0.01)",
            "hover": "#8A1505",
            "pressed": "#B11B07",
            "disabled": "#38414A"
          },
          "tertiary": {
            "default": "hsl(210 11% 7% / 0.01)",
            "hover": "#8A1505",
            "pressed": "#B11B07",
            "disabled": "#38414A"
          }
        }
      }
    },
    "status": {
      "background": {
        "translating": "#4C1D95",
        "review": "#FEF08A",
        "completed": "#083510",
        "error": "#FDD3CE",
        "ready": "#A5F3FC",
        "processing": "#38414A",
        "published": "#BDF5C7"
      },
      "text": {
        "translating": "#F5F3FF",
        "review": "#713F12",
        "completed": "#083510",
        "error": "#8A1505",
        "ready": "#164E63",
        "processing": "hsl(204 45% 98% / 0.72)",
        "published": "#083510"
      }
    }
  },
  "elevation": {
    "layer1": "0px 0px 2px rgba(72, 72, 72, 0.1), 0px 4px 6px rgba(72, 72, 72, 0.04), 0px 8px 16px rgba(72, 72, 72, 0.04), 0px 10px 20px 2px rgba(72, 72, 72, 0.02)",
    "layer2": "0px 1px 4px rgba(72, 72, 72, 0.1), 0px 4px 6px rgba(72, 72, 72, 0.04), 0px 8px 16px rgba(72, 72, 72, 0.04), 0px 10px 20px 2px rgba(72, 72, 72, 0.02), 0px 12px 24px 4px rgba(72, 72, 72, 0.04)",
    "layer3": "0px 2px 8px rgba(72, 72, 72, 0.1), 0px 4px 6px rgba(72, 72, 72, 0.04), 0px 8px 16px rgba(72, 72, 72, 0.04), 0px 12px 24px 2px rgba(72, 72, 72, 0.04), 0px 20px 48px 8px rgba(72, 72, 72, 0.1)",
    "focus": "0px 0px 0px 2px #000000, 0px 0px 0px 4px #78A4F6, 0px 0px 2px 4px #AAC4ED"
  },
  "mode": "dark"
};
